import React, { useContext } from "react";

import classnames from "classnames";
import { Check } from "icons";

import { Dropdown, Toastr, Typography } from "clearsense-ui/components";
import ThemeContext from "contexts/ThemeContext";

import { THEMES } from "./constants";

const ThemeSwitcher = () => {
  const { theme, setTheme } = useContext(ThemeContext);

  return (
    <Dropdown
      buttonStyle="text"
      buttonProps={{
        icon: THEMES.filter(themeItem => themeItem.key === theme)[0].icon,
        className: "hover:bg-white dark:hover:bg-gray-600",
      }}
      position="bottom-end"
    >
      {THEMES.map(themeItem => (
        <li
          key={themeItem.key}
          className={classnames("flex space-x-4 items-center", {
            "bg-cs-ui-pastel-blue text-primary-shade": theme === themeItem.key,
          })}
          onClick={() => {
            setTheme(themeItem.key);
            Toastr.success(
              `Theme changed to ${themeItem.title} Mode successfully`
            );
          }}
        >
          {React.createElement(themeItem.icon, { size: "18", color: "black" })}
          <Typography style="h4">{themeItem.title}</Typography>
          <span className="absolute right-5">
            {theme === themeItem.key && <Check size="18" />}
          </span>
        </li>
      ))}
    </Dropdown>
  );
};

export default ThemeSwitcher;
